import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { DefaultButton } from 'common/components';
import { withTheme } from 'common/styling/theme';
import { sendRequisites } from '../../_redux';
import { staticStyles } from './style';

const PaymentsInfoConfirmationForm = ({
  paymentConfirmInfo,
  onClose,
  handleSubmit,
  submitting,
  dispatch,
  requisites,
}) => {
  const submit = handleSubmit(() => sendRequisites({ ...requisites }, dispatch));

  return (
    <>
      <form className="PaymentsInfoConfirmationForm" onSubmit={submit}>
        <div className="PaymentsInfoConfirmationForm__info">
          {paymentConfirmInfo.map(info => (
            <div key={info.title}>
              <p>
                <b>{info.title}: </b>
                {info.value}
              </p>
            </div>
          ))}
        </div>
        <div className="PaymentsInfoConfirmationForm__actions">
          <DefaultButton
            textId="justCancel"
            ghost
            className="PaymentsInfoConfirmationForm__cancel-button"
            onClick={onClose}
            disabled={submitting}
          />
          <DefaultButton
            type="submit"
            textId="justConfirm"
            filled
            className="PaymentsInfoConfirmationForm__submit-button"
            disabled={submitting}
          />
        </div>
      </form>
      <style jsx>{staticStyles}</style>
    </>
  );
};

PaymentsInfoConfirmationForm.propTypes = {
  paymentConfirmInfo: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  requisites: PropTypes.object,
};

PaymentsInfoConfirmationForm.defaultProps = {
  requisites: {},
};

export default compose(
  withTheme(),
  connect(state => ({ addons: state.interfaceConfig.addons }), {}),
  reduxForm({
    form: 'PaymentsInfoConfirmationForm',
    onSubmitSuccess: (result, dispatch, { onClose, sendRequisitesAfterConfirmForm, addons, requisites, history }) => {
      if (onClose) {
        onClose();
      }
      if (sendRequisitesAfterConfirmForm) {
        const properties = requisites?.requisitesForm?.form ?? {};
        const isNullForm = Object.keys(properties).length ? properties.widget === 'nullform' : true;
        const forward = () => {
          if (requisites?.request.status === 'waiting_verification' && !isNullForm) {
            setTimeout(() => {
              history?.push(
                addons.includes('wallet')
                  ? `/wallet/dw/${requisites?.request?.id}`
                  : `/payments/dw/${requisites?.request?.id}`
              );
            }, 3000);
          } else {
            history?.push(
              addons.includes('wallet')
                ? `/wallet/dw/${requisites?.request?.id}`
                : `/payments/dw/${requisites?.request?.id}`
            );
          }
        };
        forward();
      }
    },
  })
)(PaymentsInfoConfirmationForm);
export { PaymentsInfoConfirmationForm };
